import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export function install() {
  Vue.component('fa-icon', FontAwesomeIcon)
}
